import OBTSingleYearMonthPicker from './OBTSingleYearMonthPicker';

export default OBTSingleYearMonthPicker;